export class IssueElementAPIModel {
  GetIssueElementsAPI: any;
  GetIssueElementByIdAPI: any;
  AddUpdateIssueElementAPI: any;
  PublisherIDAPI: any;
  issueElementPubIDAPI: any;
  IssueElementTableGridAPI: any;
  GetGroupByElements: any;
}
